import React from 'react';
import { string, bool } from 'prop-types';
import { Check } from 'components/Icons';
import classnames from 'classnames';

import './ColorItem.scss';

export default function ColorItem({ className, color, checked, dataQaPrefix }) {
    const rootClassName = classnames(className, 'color-select', {
        'color-select--active': checked,
    });

    const dataQa = dataQaPrefix ? `${dataQaPrefix}ColorElm` : 'colorElm';

    return (
        <div
            className={rootClassName}
            style={{ backgroundColor: color }}
            data-qa={dataQa}
        >
            <Check className="color-select__icon" viewBox="0 0 15 15" />
        </div>
    );
}

ColorItem.propTypes = {
    className: string,
    color: string.isRequired,
    checked: bool,
    dataQaPrefix: string,
};

ColorItem.defaultProps = {
    className: null,
    checked: false,
    dataQaPrefix: null,
};
